import * as React from 'react';

export interface DashboardLayoutConfig {
  activeNav: string;
  flush: boolean;
  hasAside: boolean;
  asideWidth?: string;
  hasSidebarNav?: boolean;
}

export interface DashboardLayoutFrameContextValue {
  asideHost: HTMLDivElement | null;
  sidebarNavHost: HTMLDivElement | null;
  setLayoutConfig: (config: DashboardLayoutConfig) => void;
}

export const DashboardLayoutFrameContext =
  React.createContext<DashboardLayoutFrameContextValue | null>(null);

export const useIsomorphicLayoutEffect =
  typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;
